/** Exact loader preset approved21 October2026;shared by homepage and inspector. */
export const APPROVED_LOADER_PRESET=Object.freeze({
  "ringEnd": 2,
  "markStart": 0.67,
  "pulseStart": 1.16,
  "apertureStart": 1.6,
  "apertureDuration": 1.04,
  "headlineStart": 2.1,
  "headlineDuration": 0.72,
  "ringFrom": 0.84,
  "ringTo": 1.96,
  "ringFadeLead": 0.25,
  "ringFadeDuration": 0.3,
  "markDuration": 0.63,
  "pulseDuration": 0.43,
  "bounce": 0.08,
  "settle": 0.36,
  "beatDuration": 1.74,
  "beatAmount": 0.109
});
